export default __webpack_public_path__ + "static/media/hydraulic_data_curved_right.0fceafe0.png";